import { GrupoMotivoPerda } from './../models/grupo-motivo-perda';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';

@Injectable({
  providedIn: 'root'
})
export class GrupoMotivoPerdaService {

  constructor(
    private http: HttpClient
  ) { }

  buscar(id) {
    return this.http.get<any>(globals.apiUrl + '/api/GrupoMotivoPerda/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  buscarTodos() {
    return this.http.get<any>(globals.apiUrl + '/api/GrupoMotivoPerda/BuscarTodos');
  }

  consultarGruposComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/GrupoMotivoPerda/ListaPag',
      {
        params: parametros
      });
  }

  salvar(grupo: GrupoMotivoPerda) {
    return this.http.post(globals.apiUrl + '/api/GrupoMotivoPerda/Salvar', grupo);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/GrupoMotivoPerda/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  softDeleteGrupo(id) {
    return this.http.delete(globals.apiUrl + '/api/GrupoMotivoPerda/SoftDelete',
      { params: new HttpParams().set('id', id) });
  }
}
